export default "__VITE_ASSET__Dl9zCm70__"